import axios from 'axios';
import { getCheckNumberPreviewQuery } from './queries';

const getNextAvailableCheckNumber = async (previewInput) => {
    try {
        const { url, body } = getCheckNumberPreviewQuery(previewInput || { paymentCategory: 'payroll', numberOfChecks: 1 });
        const { data } = await axios.post(url, body);
        return data;
    } catch (err) {
        throw new Error(err?.response?.data?.message || 'Unable to process request.');
    }
};

export default getNextAvailableCheckNumber;
